/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {
    RepeatableScreensManagerDeps,
    RepeatableScreensManager
} from '../../../../shared/step/repeatable-screen-manager.class';
import {AbmsBoardSubspecialtyService} from '../../../../../domain/model/licenses-certifications/board/abms/subspecialty/abms-board-subspecialty.service';
import {Screen} from '../../../../../components/sections/service/screen.class';
import {Observable, BehaviorSubject} from 'rxjs';
import {ActivatedRouteSnapshot} from '@angular/router';
import {merge} from 'rxjs/observable/merge';
import {NavigableNode} from '../../../../../components/sections/service/navigable-node.class';

interface Parameters {
    abmsIndex: string;
}

@Injectable()
export class AbmsBoardSubspecialtyScreensManager extends RepeatableScreensManager {

    private _abmsIndexSubject$ = new BehaviorSubject<number>(undefined as any);

    get abmsIndex() { return this._abmsIndexSubject$.getValue(); }

    set abmsIndex(value: number) { this._abmsIndexSubject$.next(value); }

    constructor(rsmm: RepeatableScreensManagerDeps, private readonly _abmsSubspecialtyService: AbmsBoardSubspecialtyService) {
        super(rsmm);
        this.screenChange$ = this.screenChange$.merge(this._abmsIndexSubject$.distinctUntilChanged().map(() => true)).publishReplay(1).refCount();
    }

    init(parent: NavigableNode<any, any>) {
        super.init(parent);
        merge(this._abmsSubspecialtyService.changes$, this._abmsIndexSubject$.distinctUntilChanged())
            .switchMap(() => this.refresh()).subscribe(() => {});
    }

    setCurrentScreen(screen: Screen, route: ActivatedRouteSnapshot) {
        super.setCurrentScreen(screen, route);
        this.abmsIndex = +(route.params as Parameters).abmsIndex;
    }

    navigateToFirstScreenWithAbmsIndex(abmsIndex: number): Observable<boolean> {
        this.abmsIndex = abmsIndex;
        return this.refreshed$.filter(value => value).first().flatMap(() => this.navigateToFirstScreen());
    }

    navigateToLastScreenWithAbmsIndex(abmsIndex: number): Observable<boolean> {
        this.abmsIndex = abmsIndex;
        return this.refreshed$.filter(value => value).first().flatMap(() => this.navigateToLastScreen());
    }

    protected _navigate(index: number): Observable<boolean> {
        return Observable.fromPromise(this._router.navigateByUrl(this._pathFromRootUsing({
            abmsIndex: this.abmsIndex,
            index: index
        })));
    }

    protected _countEntries(): Observable<number> {
        return this.abmsIndex ? this._abmsSubspecialtyService.countCurrentUserModelEntries(this.abmsIndex) : Observable.of(0);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/board/abms-subspecialty/abms-board-subspecialty-screens-manager.service.ts